import { useCallback, useSyncExternalStore } from 'react';

/**
 * Acompanha uma media query. Use só quando o comportamento muda (o calendário vira
 * agenda no celular); para aparência, prefira as variantes responsivas do Tailwind.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);

      return () => list.removeEventListener('change', onChange);
    },
    [query]
  );

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  );
}

/** Celular: abaixo de 760px, onde a sidebar vira bottom nav (mesmo ponto do token `md`). */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 759.98px)');
}
